import React, { ReactNode, useState } from "react";
import { CircularProgress, FormControl, FormHelperText, IconButton, InputAdornment, TextField } from "@mui/material";
import { KeyboardReturn } from "@mui/icons-material";

interface IScanFieldControlledProps {
    withAutoSubmit?: boolean;
    children: ReactNode;
    textValue: string;
    errorMessage?: string;
    autoFocus: boolean;
    onScan: (scannedValue: string) => Promise<void> | void;
    onTextValueChange: (text: string) => void;
}

export const ScanFieldControlled = (props: IScanFieldControlledProps) => {
    const [isScanningInProgress, setIsScanningInProgress] = useState(false);

    const handleOnKeyDown = async (keyDown: string) => {
        if (keyDown !== "Enter" || props.textValue === "") {
            return;
        }

        await handleProcess();
    };

    const handleProcess = async () => {
        if (props.withAutoSubmit) {
            setIsScanningInProgress(true);
            await props.onScan(props.textValue);
            setIsScanningInProgress(false);
        } else {
            await props.onScan(props.textValue);
        }
    };

    return <div className={"scan-field__container"}>
        <FormControl className={"scan-field__input-container"}
                     variant={"outlined"}
                     fullWidth>
            {props.children}
            <TextField data-testid={"scan-field-input"}
                       autoFocus={props.autoFocus}
                       value={props.textValue}
                       slotProps={props.withAutoSubmit ? { input: { endAdornment: <InputAdornment position="end">
                                   { isScanningInProgress ?
                                       <CircularProgress color={"inherit"} /> :
                                       <IconButton onClick={handleProcess}>
                                           <KeyboardReturn />
                                       </IconButton>}
                               </InputAdornment>,
                           }} : undefined}
                       variant={"outlined"}
                       onKeyDown={async (event: React.KeyboardEvent<any>) => await handleOnKeyDown(event.key)}
                       onChange={event => props.onTextValueChange(event.target.value ?? "")}
            />
            {props.errorMessage && <FormHelperText data-testid={"scan-field-error-text"} error>
                {props.errorMessage}
            </FormHelperText>}
        </FormControl>
    </div>;
};
